import { render } from "./VModal.vue?vue&type=template&id=8f2ceb18"
import script from "./VModal.vue?vue&type=script&lang=js"
export * from "./VModal.vue?vue&type=script&lang=js"

import "./VModal.vue?vue&type=style&index=0&id=8f2ceb18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/modal/VModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f2ceb18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f2ceb18', __exports__)) {
    api.reload('8f2ceb18', __exports__)
  }
  
  module.hot.accept("./VModal.vue?vue&type=template&id=8f2ceb18", () => {
    api.rerender('8f2ceb18', render)
  })

}


export default __exports__